export default __webpack_public_path__ + "static/media/r-resume.0cb5aada.pdf";